(function () {
  const config = (window.observability ||= { provider: 'datalayer' });

  function emit(name, detail = {}) {
    // Dispatch a namespaced CustomEvent for any listeners
    try {
      window.dispatchEvent(new CustomEvent('observability:event', { detail: { name, ...detail } }));
    } catch (e) {}

    if (config.provider === 'console') {
      try { console.debug('[obs]', name, detail); } catch (e) {}
      return;
    }

    // Default to dataLayer
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: `theme_${name}`, ...detail });
    } catch (e) {}
  }

  function sanitizeCartEvent(evt) {
    const out = { source: evt?.source };
    if (evt?.productVariantId) out.productVariantId = parseInt(evt.productVariantId);
    if (evt?.variantId) out.variantId = parseInt(evt.variantId);
    const cart = evt?.cartData;
    if (cart && typeof cart === 'object') {
      out.item_count = cart.item_count;
      out.total_price = cart.total_price;
      if (Array.isArray(cart.items)) {
        out.items = cart.items.slice(0, 5).map((i) => ({ id: i.id, quantity: i.quantity, price: i.final_line_price }));
      }
    }
    return out;
  }

  // Subscribe to cart pub/sub events where available
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (evt) => emit('cart_update', sanitizeCartEvent(evt)));
      subscribe(PUB_SUB_EVENTS.cartError, (evt) =>
        emit('cart_error', { source: evt?.source, message: evt?.message || evt?.errors })
      );
    }
  } catch (e) {}

  // Predictive search instrumentation
  function observePredictive(root = document) {
    root.querySelectorAll('predictive-search').forEach((ps) => {
      const mo = new MutationObserver((mutations) => {
        mutations.forEach((m) => {
          if (m.attributeName === 'open') {
            const isOpen = ps.hasAttribute('open');
            const q = ps.querySelector('input[type="search"]')?.value || '';
            emit(isOpen ? 'predictive_open' : 'predictive_close', { query: q });
          }
          if (m.attributeName === 'results' && ps.getAttribute('results') === 'true') {
            const count = parseInt(
              ps.querySelector('[data-predictive-search-live-region-count-value]')?.textContent || '0'
            );
            const q = ps.querySelector('input[type="search"]')?.value || '';
            emit('predictive_results', { query: q, count });
          }
        });
      });
      mo.observe(ps, { attributes: true, attributeFilter: ['open', 'results'] });

      ps.addEventListener('click', (evt) => {
        const link = evt.target.closest('a');
        if (link && ps.contains(link)) {
          emit('predictive_select', { href: link.href, text: (link.textContent || '').trim() });
        }
      });
    });
  }

  if (document.readyState !== 'loading') observePredictive();
  else document.addEventListener('DOMContentLoaded', observePredictive);

  // Search form submits
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form || !(form instanceof HTMLFormElement)) return;
    const hasSearchInput = !!form.querySelector('input[type="search"]');
    if (hasSearchInput) {
      const q = form.querySelector('input[type="search"]')?.value || '';
      emit('search_submit', { query: q });
    }
  });

  // Facets interactions
  document.addEventListener('click', (e) => {
    const applyBtn = e.target.closest('[data-apply-facets="true"]');
    if (applyBtn) emit('facets_apply', { mode: 'mobile_apply' });

    const clearAll = e.target.closest('.active-facets__button--clear');
    if (clearAll) emit('facets_clear_all', {});

    const removeChip = e.target.closest('.js-facet-remove, .active-facets__button');
    if (removeChip) emit('facet_remove', { label: (removeChip.textContent || '').trim() });
  });

  document.addEventListener('change', (e) => {
    const inFacet = e.target && e.target.closest && e.target.closest('facet-filters-form form');
    if (inFacet) {
      const name = e.target.name || e.target.id || '';
      emit('facet_change', { name });
    }
  });

  // Cart surfaces open/close
  function observeClassToggle(el, openClass = 'active', meta = {}) {
    if (!el) return;
    let prev = el.classList.contains(openClass);
    const mo = new MutationObserver(() => {
      const now = el.classList.contains(openClass);
      if (now !== prev) {
        prev = now;
        emit(now ? `${meta.surface}_open` : `${meta.surface}_close`, meta);
      }
    });
    mo.observe(el, { attributes: true, attributeFilter: ['class'] });
  }

  observeClassToggle(document.querySelector('cart-drawer'), 'active', { surface: 'cart_drawer' });
  observeClassToggle(document.getElementById('cart-notification'), 'active', { surface: 'cart_notification' });
})();
